export enum FormStatus {
	DISABLED = 'DISABLED',
	INVALID = 'INVALID',
	PENDING = 'PENDING',
	VALID = 'VALID',
}
